"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormalAttributesProvider = exports.useFormalAttributes = exports.FormalAttributesContext = void 0;
const react_1 = __importStar(require("react"));
const ramda_1 = require("ramda");
const react_redux_1 = require("react-redux");
const formal_attributes_client_1 = require("./formal-attributes.client");
const formal_attributes_utils_1 = require("./formal-attributes.utils");
const hooks_1 = require("../../hooks");
const store_1 = require("../../store");
exports.FormalAttributesContext = react_1.default.createContext({
    loadFormalAttributes: () => { },
    isLoading: false,
    getAttributeName: () => '',
    getAttributeValueName: () => '',
});
const useFormalAttributes = () => react_1.default.useContext(exports.FormalAttributesContext);
exports.useFormalAttributes = useFormalAttributes;
const MAX_PAGE_SIZE = 100;
const FormalAttributesProvider = ({ children }) => {
    const client = (0, hooks_1.useEnrichClient)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const formalAttributesMap = (0, store_1.useFormalAttributesMapSelector)();
    const formalAttributeValuesMap = (0, store_1.useFormalAttributeValuesMapSelector)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    // to prevent a large number of requests when adding new parts of attribute names/values ids
    const lockRequest = (0, react_1.useRef)(false);
    const [attributeNameIds, setAttributeNameIds] = (0, react_1.useState)(undefined);
    const [attributeValueIds, setAttributeValueIds] = (0, react_1.useState)(undefined);
    const loadFormalAttributes = (0, react_1.useCallback)((attributes, { highPriority } = {}) => {
        const uniqueAttributeNameIds = new Set();
        const uniqueAttributeValueIds = new Set();
        attributes.forEach(({ attributeId, valueId, valueName }) => {
            if (attributeId) {
                uniqueAttributeNameIds.add(attributeId);
            }
            if (valueId && !valueName) {
                uniqueAttributeValueIds.add(valueId);
            }
        });
        setAttributeNameIds((0, formal_attributes_utils_1.addIdsToLoadQueue)(Array.from(uniqueAttributeNameIds), highPriority));
        setAttributeValueIds((0, formal_attributes_utils_1.addIdsToLoadQueue)(Array.from(uniqueAttributeValueIds), highPriority));
    }, []);
    const attributeNameIdsToFetch = (0, react_1.useMemo)(() => {
        const missingAttributeIds = (0, ramda_1.without)([...formalAttributesMap.keys()], attributeNameIds !== null && attributeNameIds !== void 0 ? attributeNameIds : []);
        return missingAttributeIds.slice(0, MAX_PAGE_SIZE);
    }, [attributeNameIds, formalAttributesMap]);
    const attributeValueIdsToFetch = (0, react_1.useMemo)(() => {
        const missingAttributeValueIds = (0, ramda_1.without)([...formalAttributeValuesMap.keys()], attributeValueIds !== null && attributeValueIds !== void 0 ? attributeValueIds : []);
        return missingAttributeValueIds.slice(0, MAX_PAGE_SIZE);
    }, [attributeValueIds, formalAttributeValuesMap]);
    (0, react_1.useEffect)(() => {
        const loadAttributes = (attributeNameIdsToFetch, attributeValueIdsToFetch) => __awaiter(void 0, void 0, void 0, function* () {
            setIsLoading(true);
            lockRequest.current = true;
            const [formalAttributeNames = [], formalAttributeValues = [],] = yield Promise.all([
                attributeNameIdsToFetch.length ? (0, formal_attributes_client_1.getFormalAttributeNames)(client, attributeNameIdsToFetch) : undefined,
                attributeValueIdsToFetch.length ? (0, formal_attributes_client_1.getFormalAttributeValues)(client, attributeValueIdsToFetch) : undefined,
            ]);
            dispatch((0, store_1.attributesSetFormalAttributes)(formalAttributeNames));
            dispatch((0, store_1.attributesSetFormalAttributeValues)(formalAttributeValues));
            lockRequest.current = false;
        });
        if (!lockRequest.current) {
            if (attributeNameIdsToFetch.length || attributeValueIdsToFetch.length) {
                void loadAttributes(attributeNameIdsToFetch, attributeValueIdsToFetch);
            }
            else {
                setIsLoading(false);
            }
        }
    }, [client, dispatch, formalAttributesMap, formalAttributeValuesMap, attributeNameIdsToFetch, attributeValueIdsToFetch]);
    const getAttributeName = (0, react_1.useCallback)((attributeId) => { var _a, _b; return (_b = (_a = formalAttributesMap.get(attributeId)) === null || _a === void 0 ? void 0 : _a.displayName) !== null && _b !== void 0 ? _b : ''; }, [formalAttributesMap]);
    const getAttributeValueName = (0, react_1.useCallback)((valueId) => { var _a, _b; return (_b = (_a = formalAttributeValuesMap.get(valueId)) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : ''; }, [formalAttributeValuesMap]);
    return (react_1.default.createElement(exports.FormalAttributesContext.Provider, { value: {
            isLoading,
            loadFormalAttributes,
            getAttributeName,
            getAttributeValueName,
        } }, children));
};
exports.FormalAttributesProvider = FormalAttributesProvider;
exports.default = exports.FormalAttributesProvider;
